module.exports = function(query, modifier) {

    if (!modifier) {
        modifier = 0;
    }

    var hasInited = false;

    var resizeFunction = function() {

        if (!$(query).length) {
            return;
        }

        if (!hasInited) {
            $(query).find("img").each(function() {
                var img = new Image();
                $(img).on('load', resizeFunction);
                img.src = $(this).attr('src');
            });
        }

        var currentProcessedElems = 0;

        var processRow = function() {
            var orderedElems = [];

            // Get the elements matching the query and reset their heights
            $(query).slice(currentProcessedElems).css("height", "auto").each(function() {

                // Get the top position of the current element
                var newTopPosition = Math.round($(this).offset().top);

                orderedElems.push({
                    'elem': this,
                    'top': newTopPosition
                });
            });

            orderedElems.sort(function(a, b) {
                return a.top - b.top;
            });

            var newProcessedElems = 0;

            if (orderedElems.length > 0) {
                var previousTopPosition = orderedElems[0].top;
                var maxHeight = 0;

                for (var i = 0; i < orderedElems.length; i++) {
                    if (orderedElems[i].top === previousTopPosition) {
                        var height = $(orderedElems[i].elem).outerHeight();
                        if (height > maxHeight) {
                            maxHeight = height;
                        }

                        newProcessedElems++;
                    } else {
                        break;
                    }
                }

                $(orderedElems.map(function(x) {
                    return x.elem
                })).slice(0, newProcessedElems).css('height', (maxHeight + modifier) + 'px');

                currentProcessedElems += newProcessedElems;

                if (currentProcessedElems < $(query).length) {
                    processRow();
                }
            }
        };

        processRow();

        hasInited = true;
    };

    return resizeFunction;
};